import React, { useState, useEffect, useMemo, useRef } from 'react';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import { useForm } from 'react-hook-form';
import { Icon } from '@iconify/react/dist/iconify.js';
import {
    createNotification,
    getCountries,
    getCropShort,
    checkFarmerExists
} from '../lib/api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const customStyles = `
  .form-grid-container {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    column-gap: 1rem !important;
    gap: 0.25rem !important;
    width: 100% !important;
    margin-bottom: 0.25rem !important;
  }
  .form-grid-container > div {
    width: 100% !important;
  }
  .form-control, select, textarea {
    width: 100% !important;
    box-sizing: border-box !important;
    border-radius: 8px !important;
    padding: 8px 12px !important;
    border: 1px solid #ced4da !important;
    background: #fff !important;
    font-size: 0.875rem !important;
  }
  .form-control:focus, select:focus, textarea:focus {
    border-color: #1a73e8 !important;
    box-shadow: 0 0 0 0.2rem rgba(26, 115, 232, 0.25) !important;
    outline: none !important;
  }
  .error-message {
    color: #dc3545;
    font-size: 0.75rem;
    margin-top: 0.25rem;
  }
  .success-message {
    color: #28a745;
    font-size: 0.75rem;
    margin-top: 0.25rem;
  }
  .card-body {
    overflow-y: auto !important;
    max-height: calc(100vh - 80px) !important;
    padding: 1.5rem !important;
  }
  .drawer-header {
    padding: 1.5rem;
    border-bottom: 1px solid #dee2e6;
    position: relative;
  }
  .drawer-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #1a73e8;
  }
  .form-label {
    font-size: 0.875rem !important;
    font-weight: 600 !important;
    color: #4a4a4a !important;
    margin-bottom: 0.5rem !important;
    display: block;
  }
  .required-star {
    color: #dc3545;
  }
  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }
  .section-title {
    font-size: 1rem;
    font-weight: 600;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #e2e8f0;
  }
  .section-divider {
    margin: 0.75rem 0;
    border-top: 2px solid #e2e8f0;
  }
  .notification-type-group {
    display: flex !important;
    gap: 32px !important;
    padding: 14px 20px !important;
    background: #ffffff !important;
    border-radius: 10px !important;
    border: 2px solid #e2e8f0 !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
  }
  .notification-type-group .form-check {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
  }
  .notification-type-group .form-check-input {
    width: 20px !important;
    height: 20px !important;
    cursor: pointer !important;
  }
  .notification-type-group .form-check-input:checked {
    background-color: #1a73e8 !important;
    border-color: #1a73e8 !important;
  }
  .notification-type-group .form-check-label {
    font-size: 0.9rem !important;
    font-weight: 600 !important;
    color: #4a4a4a !important;
    cursor: pointer !important;
    display: flex !important;
    align-items: center !important;
    gap: 6px !important;
  }
  .multi-type-group {
    display: flex !important;
    gap: 24px !important;
    padding: 12px 20px !important;
    margin-top: 12px !important;
    background: #f8fafc !important;
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    margin-left: 0 !important;
  }
  .multi-type-group .form-check {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .multi-type-group .form-check-input {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  .multi-type-group .form-check-input:checked {
    background-color: #1a73e8;
    border-color: #1a73e8;
  }
  .multi-type-group .form-check-label {
    font-size: 0.8rem;
    font-weight: 500;
    color: #4b5563;
    cursor: pointer;
  }
  .filter-section {
    margin-top: 1rem;
    padding: 1rem;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
  }
  .filter-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
  @media (max-width: 768px) {
    .filter-grid {
      grid-template-columns: 1fr;
    }
  }
  .single-user-input {
    margin-top: 8px;
  }
  .farmer-details-card {
    background: #f0f7ff;
    border: 1px solid #b8d4f0;
    border-radius: 8px;
    padding: 12px 16px;
    margin-top: 8px;
  }
  .farmer-details-card .detail-row {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    font-size: 0.875rem;
  }
  .farmer-details-card .detail-label {
    font-weight: 600;
    color: #495057;
  }
  .farmer-details-card .detail-value {
    color: #212529;
  }

  /* Multi-Select Dropdown */
  .multi-select-container {
    position: relative;
    width: 100%;
  }
  .multi-select-trigger {
    width: 100%;
    min-height: 38px;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid #ced4da;
    background: #fff;
    font-size: 0.875rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    user-select: none;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .multi-select-trigger:hover {
    border-color: #adb5bd;
  }
  .multi-select-trigger.open {
    border-color: #1a73e8 !important;
    box-shadow: 0 0 0 0.2rem rgba(26, 115, 232, 0.25) !important;
  }
  .multi-select-menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 1055;
    background: #ffffff;
    border: 1px solid #ced4da;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    max-height: 280px;
    display: flex;
    flex-direction: column;
  }
  .multi-select-search-header {
    padding: 10px;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .multi-select-search-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }
  .multi-select-search-wrapper .search-icon {
    position: absolute;
    left: 10px;
    color: #64748b;
    font-size: 1rem;
    pointer-events: none;
  }
  .multi-select-search-input {
    width: 100% !important;
    padding: 7px 10px 7px 32px !important;
    border-radius: 6px !important;
    border: 1.5px solid #cbd5e1 !important;
    font-size: 0.825rem !important;
    background: #ffffff !important;
    outline: none !important;
  }
  .multi-select-search-input:focus {
    border-color: #1a73e8 !important;
    box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.15) !important;
  }
  .multi-select-list {
    overflow-y: auto;
    max-height: 210px;
  }
  .multi-select-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    font-size: 0.85rem;
    cursor: pointer;
    color: #334155;
    transition: background 0.15s;
    user-select: none;
  }
  .multi-select-item:hover {
    background: #f1f5f9;
  }
  .multi-select-item.selected {
    background: #eff6ff !important;
    color: #1d4ed8 !important;
    font-weight: 600;
  }
  .multi-select-item.select-all-header {
    border-bottom: 1px solid #f1f5f9;
    font-weight: 600;
    background: #fafafa;
  }
  .multi-select-item input[type="checkbox"] {
    width: 16px;
    height: 16px;
    accent-color: #1a73e8;
    cursor: pointer;
  }
  .no-items-found {
    padding: 16px;
    text-align: center;
    font-size: 0.825rem;
    color: #64748b;
  }
  .selected-tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
  }
  .tag-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #e8f0fe;
    color: #1a73e8;
    border: 1px solid #c2e7ff;
    border-radius: 16px;
    padding: 3px 10px;
    font-size: 0.78rem;
    font-weight: 500;
  }
  .tag-chip button {
    background: none;
    border: none;
    padding: 0;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    color: #1a73e8;
  }
  .tag-chip button:hover {
    color: #dc3545;
  }

  /* Recurrence Section - REDESIGNED */
  .recurrence-card {
    background: #ffffff;
    border: 1.5px solid #e2e8f0;
    border-radius: 12px;
    padding: 0;
    margin-top: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  }
  .recurrence-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
  }
  .recurrence-card-header-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .recurrence-card-body {
    padding: 20px;
  }
  .recurrence-type-selector {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
  }
  .recurrence-type-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 16px;
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    background: #ffffff;
    font-size: 0.875rem;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: all 0.15s ease;
  }
  .recurrence-type-btn:hover {
    border-color: #cbd5e1;
    background: #f8fafc;
  }
  .recurrence-type-btn.active {
    border-color: #1a73e8;
    background: #eff6ff;
    color: #1a73e8;
    box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
  }
  .recurrence-form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;
    align-items: end;
  }
  @media (max-width: 600px) {
    .recurrence-form-grid {
      grid-template-columns: 1fr;
    }
  }
  .recurrence-field-label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 6px;
    display: block;
  }
  .recurrence-input-group {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  }
  .recurrence-input-group .form-control {
    flex: 1 1 auto !important;
    min-width: 0 !important;
    width: auto !important;
  }
  .recurrence-input-group .recurrence-number-input {
    flex: 0 0 80px !important;
    width: 80px !important;
    min-width: 80px !important;
    max-width: 80px !important;
  }
  .recurrence-input-group .recurrence-unit-select {
    flex: 0 0 110px !important;
    width: 110px !important;
    min-width: 110px !important;
    max-width: 110px !important;
  }
  .recurrence-input-group .input-suffix {
    font-size: 0.8rem;
    font-weight: 500;
    color: #64748b;
    white-space: nowrap;
    min-width: fit-content;
  }
  .day-pills-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 4px;
  }
  .day-pill-btn {
    border: 1.5px solid #cbd5e1;
    background: #ffffff;
    color: #475569;
    border-radius: 20px;
    padding: 7px 16px;
    font-size: 0.825rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    min-width: 52px;
    text-align: center;
  }
  .day-pill-btn:hover {
    border-color: #1a73e8;
    color: #1a73e8;
    background: #f0f7ff;
  }
  .day-pill-btn.active {
    background: #1a73e8;
    border-color: #1a73e8;
    color: #ffffff;
    box-shadow: 0 2px 6px rgba(26, 115, 232, 0.3);
  }
  .recurrence-divider {
    border-top: 1px dashed #e2e8f0;
    margin: 16px 0;
  }
  .recurrence-info-box {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 14px;
    background: #f0f7ff;
    border-radius: 8px;
    border: 1px solid #dbeafe;
    margin-top: 16px;
  }
  .recurrence-info-box .info-icon {
    color: #1a73e8;
    font-size: 1.1rem;
    flex-shrink: 0;
    margin-top: 1px;
  }
  .recurrence-info-box .info-text {
    font-size: 0.78rem;
    color: #1e40af;
    line-height: 1.4;
  }
  .recurrence-switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
  }
  .recurrence-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .recurrence-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #cbd5e1;
    transition: .3s;
    border-radius: 24px;
  }
  .recurrence-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .3s;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0,0,0,0.15);
  }
  .recurrence-switch input:checked + .recurrence-slider {
    background-color: #1a73e8;
  }
  .recurrence-switch input:checked + .recurrence-slider:before {
    transform: translateX(20px);
  }
  .recurrence-summary {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.78rem;
    color: #64748b;
    margin-top: 4px;
    font-style: italic;
  }
`;

const DAYS_OF_WEEK = [
    { label: 'Sun', value: 0 },
    { label: 'Mon', value: 1 },
    { label: 'Tue', value: 2 },
    { label: 'Wed', value: 3 },
    { label: 'Thu', value: 4 },
    { label: 'Fri', value: 5 },
    { label: 'Sat', value: 6 },
];

const NotificationDrawer = ({ isOpen, onClose, onSuccess }) => {
    const [saveLoading, setSaveLoading] = useState(false);
    const [checkingFarmer, setCheckingFarmer] = useState(false);

    // Form state
    const [notificationType, setNotificationType] = useState('SINGLE');
    const [multiUserType, setMultiUserType] = useState('ALL');

    // Recurring Notification state
    const [isRecurring, setIsRecurring] = useState(false);
    const [recurrenceType, setRecurrenceType] = useState('WEEKLY'); // 'WEEKLY' | 'MONTHLY'
    const [recurrenceInterval, setRecurrenceInterval] = useState(1);
    const [selectedDaysOfWeek, setSelectedDaysOfWeek] = useState([1]); // Default Monday
    const [recurrenceDayOfMonth, setRecurrenceDayOfMonth] = useState(1);
    const [recurrenceDuration, setRecurrenceDuration] = useState(4);
    const [recurrenceDurationType, setRecurrenceDurationType] = useState('WEEK'); // 'WEEK' | 'MONTH'

    // Multi-select Crop states
    const [cropDropdownOpen, setCropDropdownOpen] = useState(false);
    const [cropSearchTerm, setCropSearchTerm] = useState('');
    const cropDropdownRef = useRef(null);
    const cropSearchInputRef = useRef(null);

    // Multi-select Country states
    const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
    const [countrySearchTerm, setCountrySearchTerm] = useState('');
    const countryDropdownRef = useRef(null);
    const countrySearchInputRef = useRef(null);

    // Filter states
    const [countriesList, setCountriesList] = useState([]);
    const [cropsList, setCropsList] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState([]);
    const [selectedCrops, setSelectedCrops] = useState([]);
    const [registrationDateFrom, setRegistrationDateFrom] = useState('');
    const [registrationDateTo, setRegistrationDateTo] = useState('');
    const [minAge, setMinAge] = useState('');
    const [maxAge, setMaxAge] = useState('');
    const [selectedGender, setSelectedGender] = useState('');

    // Single user states
    const [phoneNumber, setPhoneNumber] = useState('');
    const [selectedCountryCode, setSelectedCountryCode] = useState('');
    const [selectedCountryCodeValue, setSelectedCountryCodeValue] = useState('');
    const [farmerDetails, setFarmerDetails] = useState(null);
    const [farmerExists, setFarmerExists] = useState(false);
    const [farmerCheckMessage, setFarmerCheckMessage] = useState('');

    // Loading states
    const [loadingCountries, setLoadingCountries] = useState(false);
    const [loadingCrops, setLoadingCrops] = useState(false);
    const [dataLoaded, setDataLoaded] = useState({
        countries: false,
        crops: false,
    });

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        defaultValues: {
            title: '',
            description: '',
        },
    });

    const getAuthToken = () => {
        const token = localStorage.getItem('token');
        if (!token) {
            toast.error('Authentication token not found. Please login again.', {
                position: 'top-right',
                autoClose: 3000,
            });
            return null;
        }
        return token;
    };

    // Close dropdowns on click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (cropDropdownRef.current && !cropDropdownRef.current.contains(event.target)) {
                setCropDropdownOpen(false);
            }
            if (countryDropdownRef.current && !countryDropdownRef.current.contains(event.target)) {
                setCountryDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Focus search inputs when dropdowns open
    useEffect(() => {
        if (cropDropdownOpen && cropSearchInputRef.current) {
            setTimeout(() => cropSearchInputRef.current?.focus(), 50);
        }
    }, [cropDropdownOpen]);

    useEffect(() => {
        if (countryDropdownOpen && countrySearchInputRef.current) {
            setTimeout(() => countrySearchInputRef.current?.focus(), 50);
        }
    }, [countryDropdownOpen]);

    // Load countries and crops on drawer open
    useEffect(() => {
        if (!isOpen) return;

        const loadData = async () => {
            const token = getAuthToken();
            if (!token) return;

            if (!dataLoaded.countries) {
                setLoadingCountries(true);
                try {
                    const response = await getCountries(token);
                    const countries = response.countries || response.data || [];
                    setCountriesList(countries);

                    if (countries.length > 0 && !selectedCountryCode) {
                        setSelectedCountryCode(countries[0].ID);
                        setSelectedCountryCodeValue(countries[0].CountryCode);
                    }

                    setDataLoaded((prev) => ({ ...prev, countries: true }));
                } catch (error) {
                    console.error('Failed to load countries:', error);
                    toast.error('Failed to load countries data');
                } finally {
                    setLoadingCountries(false);
                }
            }

            if (!dataLoaded.crops) {
                setLoadingCrops(true);
                try {
                    const response = await getCropShort(token);
                    setCropsList(response.data || response || []);
                    setDataLoaded((prev) => ({ ...prev, crops: true }));
                } finally {
                    setLoadingCrops(false);
                }
            }
        };

        loadData();

        return () => {
            if (!isOpen) {
                setPhoneNumber('');
                setSelectedCountryCode('');
                setSelectedCountryCodeValue('');
                setFarmerDetails(null);
                setFarmerExists(false);
                setFarmerCheckMessage('');
                setSelectedCountries([]);
                setSelectedCrops([]);
                setCropSearchTerm('');
                setCountrySearchTerm('');
                setCropDropdownOpen(false);
                setCountryDropdownOpen(false);
                setIsRecurring(false);
                setRecurrenceType('WEEKLY');
                setRecurrenceInterval(1);
                setSelectedDaysOfWeek([1]);
                setRecurrenceDayOfMonth(1);
                setRecurrenceDuration(4);
                setRecurrenceDurationType('WEEK');
            }
        };
    }, [isOpen]);

    // Sort & filter Crops (A-Z)
    const sortedAndFilteredCrops = useMemo(() => {
        return [...cropsList]
            .sort((a, b) => {
                const nameA = (a.CropName || a.CropShortName || '').toLowerCase();
                const nameB = (b.CropName || b.CropShortName || '').toLowerCase();
                return nameA.localeCompare(nameB);
            })
            .filter((crop) => {
                const name = (crop.CropName || crop.CropShortName || '').toLowerCase();
                return name.includes(cropSearchTerm.toLowerCase().trim());
            });
    }, [cropsList, cropSearchTerm]);

    // Sort & filter Countries (A-Z)
    const sortedAndFilteredCountries = useMemo(() => {
        return [...countriesList]
            .sort((a, b) => {
                const nameA = (a.CountryName || '').toLowerCase();
                const nameB = (b.CountryName || '').toLowerCase();
                return nameA.localeCompare(nameB);
            })
            .filter((country) => {
                const name = (country.CountryName || '').toLowerCase();
                return name.includes(countrySearchTerm.toLowerCase().trim());
            });
    }, [countriesList, countrySearchTerm]);

    // Crop Handlers
    const handleToggleCrop = (cropId) => {
        if (selectedCrops.includes(cropId)) {
            setSelectedCrops((prev) => prev.filter((id) => id !== cropId));
        } else {
            setSelectedCrops((prev) => [...prev, cropId]);
        }
    };

    const handleSelectAllCrops = () => {
        const targetIds = sortedAndFilteredCrops.map((c) => c.ID);
        const isAllSelected = targetIds.length > 0 && targetIds.every((id) => selectedCrops.includes(id));

        if (isAllSelected) {
            setSelectedCrops((prev) => prev.filter((id) => !targetIds.includes(id)));
        } else {
            setSelectedCrops((prev) => Array.from(new Set([...prev, ...targetIds])));
        }
    };

    // Country Handlers
    const handleToggleCountry = (countryId) => {
        if (selectedCountries.includes(countryId)) {
            setSelectedCountries((prev) => prev.filter((id) => id !== countryId));
        } else {
            setSelectedCountries((prev) => [...prev, countryId]);
        }
    };

    const handleSelectAllCountries = () => {
        const targetIds = sortedAndFilteredCountries.map((c) => c.ID);
        const isAllSelected = targetIds.length > 0 && targetIds.every((id) => selectedCountries.includes(id));

        if (isAllSelected) {
            setSelectedCountries((prev) => prev.filter((id) => !targetIds.includes(id)));
        } else {
            setSelectedCountries((prev) => Array.from(new Set([...prev, ...targetIds])));
        }
    };

    // Day of week toggle for recurring
    const handleToggleDayOfWeek = (dayVal) => {
        if (selectedDaysOfWeek.includes(dayVal)) {
            if (selectedDaysOfWeek.length === 1) {
                toast.warning('Please select at least one day for weekly recurrence');
                return;
            }
            setSelectedDaysOfWeek(selectedDaysOfWeek.filter((d) => d !== dayVal));
        } else {
            setSelectedDaysOfWeek([...selectedDaysOfWeek, dayVal].sort((a, b) => a - b));
        }
    };

    // Single User Country selection
    const handleCountryCodeChange = (countryId) => {
        const selectedCountry = countriesList.find((c) => c.ID === countryId);
        setSelectedCountryCode(countryId);
        setSelectedCountryCodeValue(selectedCountry?.CountryCode || '');
        setFarmerDetails(null);
        setFarmerExists(false);
        setFarmerCheckMessage('');
    };

    const handleCheckFarmer = async () => {
        if (!phoneNumber || !selectedCountryCodeValue) {
            toast.error('Please enter phone number and select a country');
            return;
        }

        setCheckingFarmer(true);
        setFarmerCheckMessage('');

        try {
            const token = getAuthToken();
            if (!token) {
                setCheckingFarmer(false);
                return;
            }

            const response = await checkFarmerExists(
                {
                    phoneNumber: phoneNumber.trim(),
                    countryCode: selectedCountryCodeValue,
                },
                token
            );

            if (response.success && response.exists) {
                setFarmerExists(true);
                setFarmerDetails(response.farmer);
                setFarmerCheckMessage('Farmer found successfully!');
                toast.success('Farmer found successfully!');
            } else {
                setFarmerExists(false);
                setFarmerDetails(null);
                setFarmerCheckMessage('Farmer not found with the provided details');
                toast.error('Farmer not found');
            }
        } catch (error) {
            console.error('Error checking farmer:', error);
            setFarmerExists(false);
            setFarmerDetails(null);
            setFarmerCheckMessage('Error checking farmer. Please try again.');
            toast.error('Error checking farmer existence');
        } finally {
            setCheckingFarmer(false);
        }
    };

    const onFormSubmit = async (data) => {
        try {
            setSaveLoading(true);

            const token = getAuthToken();
            if (!token) {
                setSaveLoading(false);
                return;
            }

            if (notificationType === 'SINGLE') {
                if (!phoneNumber || !selectedCountryCodeValue) {
                    toast.error('Please enter phone number and select a country');
                    setSaveLoading(false);
                    return;
                }

                if (!farmerExists) {
                    toast.error('Please verify farmer existence first');
                    setSaveLoading(false);
                    return;
                }
            }

            if (notificationType === 'MULTI' && multiUserType === 'FILTER') {
                const filters = {
                    country: selectedCountries.length > 0 ? selectedCountries : undefined,
                    crop: selectedCrops.length > 0 ? selectedCrops : undefined,
                    registrationDateFrom: registrationDateFrom || undefined,
                    registrationDateTo: registrationDateTo || undefined,
                    minAge: minAge ? parseInt(minAge, 10) : undefined,
                    maxAge: maxAge ? parseInt(maxAge, 10) : undefined,
                    gender: selectedGender || undefined,
                };

                const hasFilters = Object.values(filters).some((v) => v !== undefined);
                if (!hasFilters) {
                    toast.error('Please apply at least one filter for filtered user notification');
                    setSaveLoading(false);
                    return;
                }
            }

            // Recurring validations
            if (isRecurring) {
                if (recurrenceType === 'WEEKLY' && (!selectedDaysOfWeek || selectedDaysOfWeek.length === 0)) {
                    toast.error('Please select at least one day of the week for weekly recurrence');
                    setSaveLoading(false);
                    return;
                }
                if (recurrenceType === 'MONTHLY' && (!recurrenceDayOfMonth || recurrenceDayOfMonth < 1 || recurrenceDayOfMonth > 31)) {
                    toast.error('Please select a valid day of the month (1-31)');
                    setSaveLoading(false);
                    return;
                }
                if (!recurrenceDuration || Number(recurrenceDuration) <= 0) {
                    toast.error('Please specify a valid duration for recurrence');
                    setSaveLoading(false);
                    return;
                }
            }

            const payload = {
                title: data.title,
                description: data.description,
                notificationType,
                ...(notificationType === 'MULTI' && { multiUserType }),
                ...(notificationType === 'SINGLE' && {
                    phoneNumber: phoneNumber.trim(),
                    countryCode: selectedCountryCodeValue,
                }),
                ...(notificationType === 'MULTI' &&
                    multiUserType === 'FILTER' && {
                    filters: {
                        country: selectedCountries.length > 0 ? selectedCountries : undefined,
                        crop: selectedCrops.length > 0 ? selectedCrops : undefined,
                        registrationDateFrom: registrationDateFrom || undefined,
                        registrationDateTo: registrationDateTo || undefined,
                        minAge: minAge ? parseInt(minAge, 10) : undefined,
                        maxAge: maxAge ? parseInt(maxAge, 10) : undefined,
                        gender: selectedGender || undefined,
                    },
                }),
                // Recurring fields
                isRecurring,
                recurrenceType: isRecurring ? recurrenceType : 'ONCE',
                recurrenceInterval: isRecurring ? Math.max(1, parseInt(recurrenceInterval, 10) || 1) : 1,
                recurrenceDaysOfWeek: isRecurring && recurrenceType === 'WEEKLY' ? selectedDaysOfWeek : null,
                recurrenceDayOfMonth: isRecurring && recurrenceType === 'MONTHLY' ? parseInt(recurrenceDayOfMonth, 10) || null : null,
                recurrenceDuration: isRecurring ? Math.max(1, parseInt(recurrenceDuration, 10) || 1) : 0,
                recurrenceDurationType: isRecurring ? recurrenceDurationType : 'WEEK',
            };

            const response = await createNotification(payload, token);

            if (response.success) {
                toast.success('Notification queued successfully!', {
                    position: 'top-right',
                    autoClose: 3000,
                });

                if (onSuccess) {
                    onSuccess();
                }

                setTimeout(() => {
                    onClose();
                    reset();
                    setPhoneNumber('');
                    setSelectedCountryCode(countriesList[0]?.ID || '');
                    setSelectedCountryCodeValue(countriesList[0]?.CountryCode || '');
                    setFarmerDetails(null);
                    setFarmerExists(false);
                    setFarmerCheckMessage('');
                    setSelectedCountries([]);
                    setSelectedCrops([]);
                    setCountrySearchTerm('');
                    setCropSearchTerm('');
                    setIsRecurring(false);
                    setRecurrenceType('WEEKLY');
                    setRecurrenceInterval(1);
                    setSelectedDaysOfWeek([1]);
                    setRecurrenceDayOfMonth(1);
                    setRecurrenceDuration(4);
                    setRecurrenceDurationType('WEEK');
                    setSaveLoading(false);
                }, 1500);
            } else {
                toast.error(response.message || 'Failed to save notification');
                setSaveLoading(false);
            }
        } catch (error) {
            console.error('Save error:', error);
            toast.error(
                error.response?.data?.message || error.message || 'An error occurred while saving.'
            );
            setSaveLoading(false);
        }
    };

    const renderNotificationType = () => (
        <div>
            <label className="form-label">
                Notification Type <span className="required-star">*</span>
            </label>
            <div className="notification-type-group">
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        id="singleUser"
                        name="notificationType"
                        value="SINGLE"
                        checked={notificationType === 'SINGLE'}
                        onChange={() => {
                            setNotificationType('SINGLE');
                            setFarmerDetails(null);
                            setFarmerExists(false);
                            setFarmerCheckMessage('');
                        }}
                    />
                    <label
                        className="form-check-label"
                        htmlFor="singleUser"
                        style={{ color: notificationType === 'SINGLE' ? '#1a73e8' : '#4a4a4a' }}
                    >
                        <Icon icon="mdi:account" style={{ fontSize: '1.1rem' }} />
                        Single User
                    </label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        id="multiUser"
                        name="notificationType"
                        value="MULTI"
                        checked={notificationType === 'MULTI'}
                        onChange={() => {
                            setNotificationType('MULTI');
                        }}
                    />
                    <label
                        className="form-check-label"
                        htmlFor="multiUser"
                        style={{ color: notificationType === 'MULTI' ? '#1a73e8' : '#4a4a4a' }}
                    >
                        <Icon icon="mdi:account-group" style={{ fontSize: '1.1rem' }} />
                        Multi User
                    </label>
                </div>
            </div>

            {notificationType === 'SINGLE' && (
                <div className="single-user-input">
                    <div className="form-grid-container">
                        <div>
                            <label className="form-label">
                                Country <span className="required-star">*</span>
                            </label>
                            <select
                                className="form-control"
                                value={selectedCountryCode}
                                onChange={(e) => handleCountryCodeChange(e.target.value)}
                            >
                                {countriesList.map((country) => (
                                    <option key={country.ID} value={country.ID}>
                                        {country.CountryName} ({country.CountryCode})
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="form-label">
                                Phone Number <span className="required-star">*</span>
                            </label>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <input
                                    type="tel"
                                    className={`form-control ${!phoneNumber ? 'border-danger' : ''}`}
                                    value={phoneNumber}
                                    onChange={(e) => {
                                        setPhoneNumber(e.target.value);
                                        setFarmerDetails(null);
                                        setFarmerExists(false);
                                        setFarmerCheckMessage('');
                                    }}
                                    placeholder="Enter phone number"
                                    style={{ flex: 1 }}
                                />
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleCheckFarmer}
                                    disabled={checkingFarmer || !phoneNumber || !selectedCountryCodeValue}
                                    style={{
                                        padding: '8px 20px',
                                        borderRadius: '8px',
                                        whiteSpace: 'nowrap',
                                        fontWeight: '500',
                                        background: '#1a73e8',
                                        color: 'white',
                                        border: 'none',
                                    }}
                                >
                                    {checkingFarmer ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" />
                                            Checking
                                        </>
                                    ) : (
                                        'Verify'
                                    )}
                                </button>
                            </div>
                            {!phoneNumber && (
                                <span className="error-message">Phone number is required</span>
                            )}
                        </div>
                    </div>

                    {farmerCheckMessage && (
                        <div className={farmerExists ? 'success-message' : 'error-message'}>
                            {farmerCheckMessage}
                        </div>
                    )}

                    {farmerExists && farmerDetails && (
                        <div className="farmer-details-card">
                            <div className="detail-row">
                                <span className="detail-label">Name:</span>
                                <span className="detail-value">
                                    {farmerDetails.GivenName} {farmerDetails.FamilyName}
                                </span>
                            </div>
                            <div className="detail-row">
                                <span className="detail-label">Gender:</span>
                                <span className="detail-value">{farmerDetails.Gender || 'N/A'}</span>
                            </div>
                            <div className="detail-row">
                                <span className="detail-label">Age:</span>
                                <span className="detail-value">{farmerDetails.Age || 'N/A'}</span>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {notificationType === 'MULTI' && (
                <div className="multi-type-group">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            id="allUsers"
                            name="multiUserType"
                            value="ALL"
                            checked={multiUserType === 'ALL'}
                            onChange={() => {
                                setMultiUserType('ALL');
                            }}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="allUsers"
                            style={{ color: multiUserType === 'ALL' ? '#1a73e8' : '#4b5563' }}
                        >
                            All Users
                        </label>
                    </div>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            id="filterUsers"
                            name="multiUserType"
                            value="FILTER"
                            checked={multiUserType === 'FILTER'}
                            onChange={() => {
                                setMultiUserType('FILTER');
                            }}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="filterUsers"
                            style={{ color: multiUserType === 'FILTER' ? '#1a73e8' : '#4b5563' }}
                        >
                            Filter Users
                        </label>
                    </div>
                </div>
            )}
        </div>
    );

    const renderRecurringSection = () => {
        // Build a human-readable summary
        const getRecurrenceSummary = () => {
            if (!isRecurring) return '';
            const interval = Math.max(1, parseInt(recurrenceInterval, 10) || 1);
            const duration = Math.max(1, parseInt(recurrenceDuration, 10) || 1);
            const durationLabel = duration === 1
                ? (recurrenceDurationType === 'WEEK' ? 'week' : 'month')
                : (recurrenceDurationType === 'WEEK' ? 'weeks' : 'months');

            if (recurrenceType === 'WEEKLY') {
                const dayNames = selectedDaysOfWeek
                    .map(d => DAYS_OF_WEEK.find(day => day.value === d)?.label)
                    .filter(Boolean)
                    .join(', ');
                return `Repeats every ${interval} week${interval > 1 ? 's' : ''} on ${dayNames} for ${duration} ${durationLabel}`;
            }
            return `Repeats every ${interval} month${interval > 1 ? 's' : ''} on day ${recurrenceDayOfMonth} for ${duration} ${durationLabel}`;
        };

        return (
            <div className="recurrence-card">
                <div className="recurrence-card-header">
                    <div className="recurrence-card-header-left">
                        <Icon icon="mdi:calendar-sync-outline" style={{ fontSize: '1.4rem', color: '#1a73e8' }} />
                        <div>
                            <span className="fw-semibold text-dark d-block" style={{ fontSize: '0.95rem' }}>
                                Recurring Schedule
                            </span>
                            <span className="text-muted" style={{ fontSize: '0.78rem' }}>
                                {isRecurring ? 'Recurring notification is active' : 'Set up a recurring notification'}
                            </span>
                        </div>
                    </div>
                    <label className="recurrence-switch">
                        <input
                            type="checkbox"
                            checked={isRecurring}
                            onChange={(e) => setIsRecurring(e.target.checked)}
                        />
                        <span className="recurrence-slider"></span>
                    </label>
                </div>

                {isRecurring && (
                    <div className="recurrence-card-body">
                        {/* Recurrence Type Selector */}
                        <div className="recurrence-type-selector">
                            <button
                                type="button"
                                className={`recurrence-type-btn ${recurrenceType === 'WEEKLY' ? 'active' : ''}`}
                                onClick={() => setRecurrenceType('WEEKLY')}
                            >
                                <Icon icon="mdi:calendar-week" style={{ fontSize: '1.2rem' }} />
                                Weekly
                            </button>
                            <button
                                type="button"
                                className={`recurrence-type-btn ${recurrenceType === 'MONTHLY' ? 'active' : ''}`}
                                onClick={() => setRecurrenceType('MONTHLY')}
                            >
                                <Icon icon="mdi:calendar-month" style={{ fontSize: '1.2rem' }} />
                                Monthly
                            </button>
                        </div>

                        {/* Weekly Days Picker */}
                        {recurrenceType === 'WEEKLY' && (
                            <div style={{ marginBottom: '20px' }}>
                                <label className="recurrence-field-label">
                                    Days of Week <span className="required-star">*</span>
                                </label>
                                <div className="day-pills-group">
                                    {DAYS_OF_WEEK.map((d) => {
                                        const isSelected = selectedDaysOfWeek.includes(d.value);
                                        return (
                                            <button
                                                key={d.value}
                                                type="button"
                                                className={`day-pill-btn ${isSelected ? 'active' : ''}`}
                                                onClick={() => handleToggleDayOfWeek(d.value)}
                                            >
                                                {d.label}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {/* Monthly Day of Month Picker */}
                        {recurrenceType === 'MONTHLY' && (
                            <div style={{ marginBottom: '20px' }}>
                                <label className="recurrence-field-label">
                                    Day of Month <span className="required-star">*</span>
                                </label>
                                <div className="recurrence-input-group">
                                    <span className="input-suffix">Every</span>
                                    <input
                                        type="number"
                                        className="form-control"
                                        style={{ width: '100px', flex: 'none' }}
                                        min="1"
                                        max="31"
                                        value={recurrenceDayOfMonth}
                                        onChange={(e) => setRecurrenceDayOfMonth(Math.max(1, Math.min(31, parseInt(e.target.value, 10) || 1)))}
                                    />
                                    <span className="input-suffix">day of the month</span>
                                </div>
                            </div>
                        )}

                        <div className="recurrence-divider" />

                        {/* Interval & Duration */}
                        <div className="recurrence-form-grid">
                            <div>
                                <label className="recurrence-field-label">
                                    Repeat Every <span className="required-star">*</span>
                                </label>
                                <div className="recurrence-input-group">
                                    <input
                                        type="number"
                                        className="form-control recurrence-number-input"
                                        min="1"
                                        value={recurrenceInterval}
                                        onChange={(e) => setRecurrenceInterval(Math.max(1, parseInt(e.target.value, 10) || 1))}
                                    />
                                    <span className="input-suffix">
                                        {recurrenceType === 'WEEKLY' ? 'week(s)' : 'month(s)'}
                                    </span>
                                </div>
                            </div>

                            <div>
                                <label className="recurrence-field-label">
                                    End Recurrence After <span className="required-star">*</span>
                                </label>
                                <div className="recurrence-input-group">
                                    <input
                                        type="number"
                                        className="form-control recurrence-number-input"
                                        min="1"
                                        value={recurrenceDuration}
                                        onChange={(e) => setRecurrenceDuration(Math.max(1, parseInt(e.target.value, 10) || 1))}
                                    />
                                    <select
                                        className="form-control recurrence-unit-select"
                                        value={recurrenceDurationType}
                                        onChange={(e) => setRecurrenceDurationType(e.target.value)}
                                    >
                                        <option value="WEEK">Weeks</option>
                                        <option value="MONTH">Months</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Summary */}
                        <div className="recurrence-info-box">
                            <Icon icon="mdi:information-outline" className="info-icon" />
                            <span className="info-text">{getRecurrenceSummary()}</span>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const renderFilters = () => {
        if (notificationType !== 'MULTI' || multiUserType !== 'FILTER') return null;

        return (
            <div className="filter-section">
                <h6 className="section-title">Filter Options</h6>
                <p className="text-muted" style={{ fontSize: '0.8rem', marginBottom: '1rem' }}>
                    Apply filters to target specific farmers. At least one filter is required.
                </p>

                <div className="filter-grid">
                    {/* Searchable Multi-Select Country Filter */}
                    <div ref={countryDropdownRef}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '0.5rem',
                            }}
                        >
                            <label className="form-label" style={{ marginBottom: 0 }}>
                                Countries
                            </label>
                            {selectedCountries.length > 0 && (
                                <button
                                    type="button"
                                    onClick={() => setSelectedCountries([])}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        color: '#dc3545',
                                        fontSize: '0.75rem',
                                        cursor: 'pointer',
                                        padding: 0,
                                        fontWeight: '500',
                                    }}
                                >
                                    Clear all ({selectedCountries.length})
                                </button>
                            )}
                        </div>

                        <div className="multi-select-container">
                            <div
                                className={`multi-select-trigger ${countryDropdownOpen ? 'open' : ''}`}
                                onClick={() => setCountryDropdownOpen(!countryDropdownOpen)}
                            >
                                <span style={{ color: selectedCountries.length === 0 ? '#6c757d' : '#212529' }}>
                                    {selectedCountries.length === 0
                                        ? 'Select / Search Countries...'
                                        : selectedCountries.length === countriesList.length
                                            ? 'All Countries Selected'
                                            : `${selectedCountries.length} country(s) selected`}
                                </span>
                                <Icon
                                    icon={countryDropdownOpen ? 'lucide:chevron-up' : 'lucide:chevron-down'}
                                    style={{ fontSize: '1rem', color: '#6c757d' }}
                                />
                            </div>

                            {countryDropdownOpen && (
                                <div className="multi-select-menu">
                                    <div className="multi-select-search-header" onClick={(e) => e.stopPropagation()}>
                                        <div className="multi-select-search-wrapper">
                                            <Icon icon="lucide:search" className="search-icon" />
                                            <input
                                                ref={countrySearchInputRef}
                                                type="text"
                                                className="multi-select-search-input"
                                                placeholder="Type to search countries..."
                                                value={countrySearchTerm}
                                                onChange={(e) => setCountrySearchTerm(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="multi-select-list">
                                        {sortedAndFilteredCountries.length > 0 && (
                                            <div
                                                className={`multi-select-item select-all-header ${sortedAndFilteredCountries.every((c) => selectedCountries.includes(c.ID))
                                                        ? 'selected'
                                                        : ''
                                                    }`}
                                                onClick={handleSelectAllCountries}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={sortedAndFilteredCountries.every((c) => selectedCountries.includes(c.ID))}
                                                    onChange={() => { }}
                                                />
                                                <span>
                                                    {countrySearchTerm
                                                        ? `Select All Filtered (${sortedAndFilteredCountries.length})`
                                                        : `Select All (${countriesList.length})`}
                                                </span>
                                            </div>
                                        )}

                                        {sortedAndFilteredCountries.length > 0 ? (
                                            sortedAndFilteredCountries.map((country) => {
                                                const isSelected = selectedCountries.includes(country.ID);
                                                return (
                                                    <div
                                                        key={country.ID}
                                                        className={`multi-select-item ${isSelected ? 'selected' : ''}`}
                                                        onClick={() => handleToggleCountry(country.ID)}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={isSelected}
                                                            onChange={() => { }}
                                                        />
                                                        <span>{country.CountryName}</span>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className="no-items-found">No countries match "{countrySearchTerm}"</div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>

                        {selectedCountries.length > 0 && (
                            <div className="selected-tags-container">
                                {selectedCountries.map((countryId) => {
                                    const country = countriesList.find((c) => c.ID === countryId);
                                    const name = country ? country.CountryName : countryId;
                                    return (
                                        <span key={countryId} className="tag-chip">
                                            {name}
                                            <button
                                                type="button"
                                                onClick={() => handleToggleCountry(countryId)}
                                                title="Remove"
                                            >
                                                <Icon icon="lucide:x" style={{ fontSize: '0.85rem' }} />
                                            </button>
                                        </span>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    {/* Searchable Multi-Select Crop Filter */}
                    <div ref={cropDropdownRef}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '0.5rem',
                            }}
                        >
                            <label className="form-label" style={{ marginBottom: 0 }}>
                                Crops
                            </label>
                            {selectedCrops.length > 0 && (
                                <button
                                    type="button"
                                    onClick={() => setSelectedCrops([])}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        color: '#dc3545',
                                        fontSize: '0.75rem',
                                        cursor: 'pointer',
                                        padding: 0,
                                        fontWeight: '500',
                                    }}
                                >
                                    Clear all ({selectedCrops.length})
                                </button>
                            )}
                        </div>

                        <div className="multi-select-container">
                            <div
                                className={`multi-select-trigger ${cropDropdownOpen ? 'open' : ''}`}
                                onClick={() => setCropDropdownOpen(!cropDropdownOpen)}
                            >
                                <span style={{ color: selectedCrops.length === 0 ? '#6c757d' : '#212529' }}>
                                    {selectedCrops.length === 0
                                        ? 'Select / Search Crops...'
                                        : selectedCrops.length === cropsList.length
                                            ? 'All Crops Selected'
                                            : `${selectedCrops.length} crop(s) selected`}
                                </span>
                                <Icon
                                    icon={cropDropdownOpen ? 'lucide:chevron-up' : 'lucide:chevron-down'}
                                    style={{ fontSize: '1rem', color: '#6c757d' }}
                                />
                            </div>

                            {cropDropdownOpen && (
                                <div className="multi-select-menu">
                                    <div className="multi-select-search-header" onClick={(e) => e.stopPropagation()}>
                                        <div className="multi-select-search-wrapper">
                                            <Icon icon="lucide:search" className="search-icon" />
                                            <input
                                                ref={cropSearchInputRef}
                                                type="text"
                                                className="multi-select-search-input"
                                                placeholder="Type to search crops..."
                                                value={cropSearchTerm}
                                                onChange={(e) => setCropSearchTerm(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="multi-select-list">
                                        {sortedAndFilteredCrops.length > 0 && (
                                            <div
                                                className={`multi-select-item select-all-header ${sortedAndFilteredCrops.every((c) => selectedCrops.includes(c.ID))
                                                        ? 'selected'
                                                        : ''
                                                    }`}
                                                onClick={handleSelectAllCrops}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={sortedAndFilteredCrops.every((c) => selectedCrops.includes(c.ID))}
                                                    onChange={() => { }}
                                                />
                                                <span>
                                                    {cropSearchTerm
                                                        ? `Select All Filtered (${sortedAndFilteredCrops.length})`
                                                        : `Select All (${cropsList.length})`}
                                                </span>
                                            </div>
                                        )}

                                        {sortedAndFilteredCrops.length > 0 ? (
                                            sortedAndFilteredCrops.map((crop) => {
                                                const isSelected = selectedCrops.includes(crop.ID);
                                                return (
                                                    <div
                                                        key={crop.ID}
                                                        className={`multi-select-item ${isSelected ? 'selected' : ''}`}
                                                        onClick={() => handleToggleCrop(crop.ID)}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={isSelected}
                                                            onChange={() => { }}
                                                        />
                                                        <span>{crop.CropName || crop.CropShortName}</span>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className="no-items-found">No crops match "{cropSearchTerm}"</div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>

                        {selectedCrops.length > 0 && (
                            <div className="selected-tags-container">
                                {selectedCrops.map((cropId) => {
                                    const crop = cropsList.find((c) => c.ID === cropId);
                                    const name = crop ? crop.CropName || crop.CropShortName : cropId;
                                    return (
                                        <span key={cropId} className="tag-chip">
                                            {name}
                                            <button
                                                type="button"
                                                onClick={() => handleToggleCrop(cropId)}
                                                title="Remove"
                                            >
                                                <Icon icon="lucide:x" style={{ fontSize: '0.85rem' }} />
                                            </button>
                                        </span>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    {/* Registration Date From */}
                    <div>
                        <label className="form-label">Registration Date From</label>
                        <input
                            type="date"
                            className="form-control"
                            value={registrationDateFrom}
                            onChange={(e) => setRegistrationDateFrom(e.target.value)}
                        />
                    </div>

                    {/* Registration Date To */}
                    <div>
                        <label className="form-label">Registration Date To</label>
                        <input
                            type="date"
                            className="form-control"
                            value={registrationDateTo}
                            onChange={(e) => setRegistrationDateTo(e.target.value)}
                        />
                    </div>

                    {/* Min Age */}
                    <div>
                        <label className="form-label">Min Age</label>
                        <input
                            type="number"
                            className="form-control"
                            value={minAge}
                            onChange={(e) => setMinAge(e.target.value)}
                            placeholder="e.g., 18"
                            min="0"
                        />
                    </div>

                    {/* Max Age */}
                    <div>
                        <label className="form-label">Max Age</label>
                        <input
                            type="number"
                            className="form-control"
                            value={maxAge}
                            onChange={(e) => setMaxAge(e.target.value)}
                            placeholder="e.g., 65"
                            min="0"
                        />
                    </div>

                    {/* Gender Filter */}
                    <div>
                        <label className="form-label">Gender</label>
                        <select
                            className="form-control"
                            value={selectedGender}
                            onChange={(e) => setSelectedGender(e.target.value)}
                        >
                            <option value="">All Genders</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <style>{customStyles}</style>
            <Drawer open={isOpen} onClose={onClose} direction="right" size={750} style={{ zIndex: 1050 }}>
                <div className="drawer-header">
                    <h6 className="drawer-title">Add New Notification</h6>
                    <button
                        onClick={onClose}
                        style={{
                            position: 'absolute',
                            right: '1rem',
                            top: '1rem',
                            background: 'none',
                            border: 'none',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            color: '#6c757d',
                        }}
                    >
                        <Icon icon="lucide:x" />
                    </button>
                </div>

                <div className="card-body">
                    {saveLoading && (
                        <div className="loading-overlay">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    <form onSubmit={handleSubmit(onFormSubmit)}>
                        {/* Title */}
                        <div>
                            <label className="form-label">
                                Title <span className="required-star">*</span>
                            </label>
                            <input
                                type="text"
                                className={`form-control ${errors.title ? 'border-danger' : ''}`}
                                {...register('title', { required: 'Title is required' })}
                                placeholder="Enter notification title"
                            />
                            {errors.title && <span className="error-message">{errors.title.message}</span>}
                        </div>

                        {/* Description */}
                        <div>
                            <label className="form-label">
                                Description <span className="required-star">*</span>
                            </label>
                            <textarea
                                className={`form-control ${errors.description ? 'border-danger' : ''}`}
                                rows="3"
                                {...register('description', { required: 'Description is required' })}
                                placeholder="Enter notification description"
                            />
                            {errors.description && (
                                <span className="error-message">{errors.description.message}</span>
                            )}
                        </div>

                        <hr className="section-divider" />

                        {/* Notification Type */}
                        {renderNotificationType()}

                        <hr className="section-divider" />

                        {/* Recurring Settings */}
                        {renderRecurringSection()}

                        <hr className="section-divider" />

                        {/* Filters */}
                        {renderFilters()}

                        <div
                            className="d-flex align-items-center justify-content-center gap-3 mt-24"
                            style={{ marginTop: '2rem' }}
                        >
                            <button
                                type="button"
                                className="btn btn-secondary px-48 py-10 radius-8"
                                onClick={onClose}
                                disabled={saveLoading}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-yellow px-48 py-10 radius-8"
                                disabled={saveLoading || (notificationType === 'SINGLE' && !farmerExists)}
                            >
                                {saveLoading ? 'Saving...' : 'Send Notification'}
                            </button>
                        </div>
                    </form>
                </div>
            </Drawer>
        </>
    );
};

export default NotificationDrawer;